module.exports = __webpack_public_path__ + "static/media/puzzle-28-bg.e6eb7c97.svg";